import { reactive, set } from 'vue';
import { ls } from '../persist/persist.js';

/**
 * autoState creates an object with a reactive value and setters for each key in the initialState.
 * The setters are auto-generated and will update the reactive value when called.
 */
const autoState = (initialState, options) => {
    const initialValue = (options === null || options === void 0 ? void 0 : options.persist) ? ls.reactive(options.persist.lsKey, initialState, true) : reactive(initialState);
    const state = {
        value: initialValue,
        set: {
            ...Object.keys(initialState).reduce((acc, _key) => {
                const key = _key;
                acc[key] = ((value) => {
                    if (typeof key === 'symbol')
                        return;
                    set(state.value, key, value);
                });
                return acc;
            }, {}),
            value: (val) => {
                Object.assign(state.value, val);
            },
        },
    };
    return state;
};

export { autoState };
